// eslint-disable-next-line jira/filename-case
import React, { useCallback, useState } from 'react';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuSection, MenuSectionHeading } from '@atlaskit/side-nav-items/menu-section';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { AppRecommendations } from '../common/types.tsx';
import { useSelectedRecommendation } from '../controllers/useSelectedRecommendation.tsx';

import { recommendationsList } from './recommendationsList.tsx';

const sectionTitle = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-growth-recommendations.section-title',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Recommended',
	description:
		'section title for the recommended section that is displayed within projects expandable menu of nav4 sidebar',
});

type RecommendationProps = {
	appRecommendations: AppRecommendations;
	sessionId?: string | null;
};

export const Recommendations = ({
	appRecommendations,
	sessionId,
}: RecommendationProps): false | React.JSX.Element | null | undefined => {
	const [isDismissed, setIsDismissed] = useState(false);
	const { formatMessage } = useIntl();
	const selectedRecommendationState = useSelectedRecommendation({
		appRecommendations,
	});
	const onDismissRecommendation = useCallback(() => {
		setIsDismissed(true);
	}, []);

	if (!selectedRecommendationState?.recommendationKey) return null;

	const selectedRecommendation = recommendationsList.find(
		(recommendation) => recommendation.key === selectedRecommendationState.recommendationKey,
	);

	return (
		selectedRecommendation &&
		!isDismissed && (
			<>
				<MenuListItem>
					<MenuSection>
						<MenuSectionHeading>{formatMessage(sectionTitle)}</MenuSectionHeading>
						<MenuList>
							<selectedRecommendation.Component
								recommendationKey={selectedRecommendation.key}
								dismissRecommendation={onDismissRecommendation}
								sessionId={sessionId}
							/>
							<FireScreenAnalytics
								attributes={{ recommendationType: selectedRecommendation.key }}
							/>
						</MenuList>
					</MenuSection>
				</MenuListItem>
			</>
		)
	);
};
